import {defineNuxtPlugin, useRequestHeaders} from '#app'
import {ApiService} from '~/services/ApiService'

export default defineNuxtPlugin(() => {
  const apiService = new ApiService(); // Accessing public runtime config
  apiService.Headers = useRequestHeaders(['cookie']);

  return {
    provide: {
      apiService
    }
  }
})